import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You'll notice that one of the parameters in the `}<inlineCode parentName="p">{`identify`}</inlineCode>{` method is a `}<inlineCode parentName="p">{`properties`}</inlineCode>{` object. `}</p>
    <p>{`This enables you to set `}<a parentName="p" {...{
        "href": "/docs/product-analytics/person-properties"
      }}>{`person properties`}</a>{`. `}</p>
    <p>{`Whenever possible, we recommend passing in all person properties you have available each time you call identify, as this ensures their person profile on PostHog is up to date.`}</p>
    <p>{`Person properties can also be set being adding a `}<inlineCode parentName="p">{`$set`}</inlineCode>{` property to a event `}<inlineCode parentName="p">{`capture`}</inlineCode>{` call. `}</p>
    <p>{`See our `}<a parentName="p" {...{
        "href": "/docs/product-analytics/person-properties"
      }}>{`person properties docs`}</a>{` for more details on how to work with them and best practices.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      